export default class ProjectIdsEnum {
  static get RafalaUk() {
    return 1;
  }
  static get Enoteca() {
    return 2;
  }
}
